import { useState } from 'react'

export default function EndScreen({ results, onRestart }) {
  const [showShare, setShowShare] = useState(false)
  const score = results.filter(Boolean).length
  const SHARE_TEXT = `J'ai reconnu ${score}/${results.length} villes du monde ! Peux-tu faire mieux ?`
  const SHARE_URL = window.location.href

  const links = [
    {
      label: 'Copier',
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2"/>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
        </svg>
      ),
      action: () => navigator.clipboard.writeText(SHARE_TEXT + ' ' + SHARE_URL)
    },
    {
      label: 'WhatsApp',
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
        </svg>
      ),
      href: `https://wa.me/?text=${encodeURIComponent(SHARE_TEXT + ' ' + SHARE_URL)}`
    },
    {
      label: 'Email',
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
      ),
      href: `mailto:?subject=CityScape Quiz&body=${encodeURIComponent(SHARE_TEXT + ' ' + SHARE_URL)}`
    }
  ]

  const handleShareBtn = () => {
    setShowShare(s => !s)
  }

  return (
    <div className="screen end-screen">
      <h2 className="end-title">Score : {score} / {results.length}</h2>

      <div className="recap">
        {results.map((r, i) => (
          <div key={i} className={`icon ${r ? 'icon-correct' : 'icon-incorrect'} icon-reveal`} />
        ))}
      </div>
    <div className="end-actions-wrapper">
      <div className="end-actions">
        <button className="start-btn" onClick={onRestart}>
          Rejouer
        </button>
        <button className="share-btn-main" onClick={handleShareBtn}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M22 2L11 13M22 2L15 22 11 13 2 9l20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        </button>
      </div>

      {showShare && (
        <div className="share-box">
          {links.map((l, i) => (
            l.href
              ? <a key={i} href={l.href} target="_blank" rel="noreferrer" className="share-item">
                  <span>{l.icon}</span>
                  <span>{l.label}</span>
                </a>
              : <button key={i} onClick={l.action} className="share-item">
                  <span>{l.icon}</span>
                  <span>{l.label}</span>
                </button>
          ))}
        </div>
      )}
      </div>
    </div>
  )
}